import { getEnv } from "../config/getEnv";

export function isPlatformSessionMode(): boolean {
  return (getEnv("REACT_APP_SF_USE_PLATFORM_SESSION") || "false") === "true";
}
